import { render, staticRenderFns } from "./UserRole.vue?vue&type=template&id=2fee84f8&scoped=true"
import script from "./UserRole.vue?vue&type=script&lang=js"
export * from "./UserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fee84f8",
  null
  
)

export default component.exports